import { useQuery } from "@tanstack/react-query";
import { checkReady } from "@/shared/api/auth.api";

/**
 * Polling cada 30s del endpoint `/health/ready` del backend. Usado por
 * el dashboard para mostrar el estado del sistema. `retry: false` para
 * que un fallo se refleje inmediatamente como "Down" en vez de
 * spinnear varios segundos.
 *
 * `enabled` apaga el polling cuando la tarjeta de estado no se pinta (hoy
 * solo la ve Administración) · un rol que no muestra la salud no debe
 * consultar el endpoint cada 30s.
 */
export function useHealthCheck(enabled = true) {
  return useQuery({
    queryKey: ["health", "ready"],
    queryFn: () => checkReady(),
    refetchInterval: 30_000,
    retry: false,
    enabled,
  });
}
